import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../base/components/container.js";
import HtmlContent from "../../../../base/components/html_content.js";

import { ProjectModel } from "../../../../models/projects/project_model.js";

const blockStyles = makeStyles(theme => ({
  root: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  }
}));

const DeveloperBlock =  (props) => {

  const classes = blockStyles();
  const { className, project } = props;
  const { developer } = project;
  if(!developer) {
    return (null);
  }
  return (
    <Container className = { clsx(classes.root, className) } >
      <h3>
        { ProjectModel.fieldDisplayName("developer") }
      </h3>
      <h4>
        { developer.name }
      </h4>
      <HtmlContent>
        { developer.sanitizedDescription }
      </HtmlContent>
    </Container>
  );
}

export default DeveloperBlock;